import { Form, FormField } from '@/libs/form'
import { isAfterOrEqualToDate, isBeforeOrEqualToDate } from '@/libs/form/validators'
import { differenceInMonths } from 'date-fns'

export class FinmaReportForm extends Form {
    compose () {
        const MAX_REPORTING_PERIOD_IN_MONTH = 18

        this.addField(new FormField('dateFrom', {
            label: 'forms.field.label.finma-report.accounting-period--from',
            type: 'calendar',
            validators: [
                { type: 'required' },
                { type: 'date' },
                {
                    type: 'isBeforeOrEqualToDate',
                    validator: () => {
                        return isBeforeOrEqualToDate(this.getItem('dateFrom').value, this.getItem('dateUntil').value)
                    },
                    params: {
                        targetLabel: 'forms.field.label.finma-report.accounting-period--to',
                    },
                },
            ],
        }))

        this.addField(new FormField('dateUntil', {
            label: 'forms.field.label.finma-report.accounting-period--to',
            type: 'calendar',
            validators: [
                { type: 'required' },
                { type: 'date' },
                {
                    type: 'isAfterOrEqualToDate',
                    validator: () => {
                        return isAfterOrEqualToDate(this.getItem('dateUntil').value, this.getItem('dateFrom').value)
                    },
                    params: {
                        targetLabel: 'forms.field.label.finma-report.accounting-period--from',
                    },
                },
                {
                    type: 'maxDifferenceInMonths',
                    validator: () => {
                        const dateFrom = this.getItem('dateFrom').value
                        const dateUntil = this.getItem('dateUntil').value

                        if (dateFrom && dateUntil) {
                            const fromDate = new Date(dateFrom)
                            const untilDate = new Date(dateUntil)

                            const monthsDifference = differenceInMonths(untilDate, fromDate)
                            return monthsDifference < MAX_REPORTING_PERIOD_IN_MONTH
                        }

                        return true
                    },
                    errorMessageTranslationKey: 'common.error-message.max-difference-in-months--until',
                    params: {
                        targetLabel: 'forms.field.label.finma-report.accounting-period--from',
                        maxDifferenceInMonths: MAX_REPORTING_PERIOD_IN_MONTH,
                    },
                },
            ],
        }))
    }
}
